import axios from "axios";

function decodeToken(encoded) {
  try {
    return atob(encoded);
  } catch (e) {
    return null;
  }
}

const axiosInstance = axios.create({
  baseURL: "https://api.spici.ir",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.url.includes("/otp/")) {
      const encodedToken = localStorage.getItem("access_token");

      // فقط اگر توکن هست و معتبره، ست کن
      if (encodedToken) {
        const token = decodeToken(encodedToken);
        if (token && token !== "undefined" && token !== "null") {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      localStorage.getItem("refresh_token")
    ) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        const res = await axios.post(
          process.env.REACT_APP_API_BASE_URL + "/otp/refresh/",
          {
            refresh: atob(localStorage.getItem("refresh_token")),
          }
        );

        const { access } = res.data;
        const encodedAccess = btoa(access);
        localStorage.setItem("access_token", encodedAccess);
        processQueue(null, access);
        originalRequest.headers["Authorization"] = "Bearer " + access;
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
        localStorage.removeItem("user_phone");
        window.location.href = "/subscription";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
